"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var PercentageBar_1 = __importDefault(require("../PercentageBar/PercentageBar"));
var Breakpoints_styles_1 = require("./Breakpoints.styles");
var Breakpoints = function (_a) {
    var values = _a.values;
    var styles = (0, Breakpoints_styles_1.useStyles)();
    var sum = values.reduce(function (value, item) {
        return value + item.value;
    }, 0);
    return ((0, jsx_runtime_1.jsx)("div", { children: values.map(function (breakpoint, index) {
            return (0, jsx_runtime_1.jsx)(PercentageBar_1.default, { className: styles.item, label: breakpoint.label, title: "".concat(breakpoint.value, " Besucher"), percentage: Math.round((breakpoint.value / sum) * 100) }, index);
        }) }));
};
exports.default = Breakpoints;
